import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Dealer } from "./dealer.model";
import { UIService } from 'src/app/shared/ui.service';
import { DealerStatus } from './dealerstatus.model';


@Injectable({
  providedIn: 'root'
})
export class DealerService {

  dealersChanged = new Subject<Dealer[]>();
  private availableDealers: Dealer[] = [];
  public dealerData: Dealer;
  public dbupdate: boolean = false;
  constructor(private http: HttpClient, private router: Router, private uiservice: UIService) { }
  public dealerStatus: DealerStatus[] = [{ id: 0, statusname: 'InActive' }, { id: 1, statusname: 'Active' }, { id: 2, statusname: 'Paused' }]
  getDealers(): Observable<Dealer[]> {
    return this.http.get<Dealer[]>('/api/Dealer/GetDealers');
  }
  fetchDealers() {
    this.http.get<Dealer[]>('/api/Dealer/GetDealers')
      .subscribe(result => {
        this.availableDealers = result;
        this.dealersChanged.next([...this.availableDealers]);
      });
  }

  addDealer(dealer: Dealer) {
    this.http.post<boolean>('/api/Dealer/', dealer)
      .subscribe(
        result => {
          this.dbupdate = result;
          if (this.dbupdate) {
            this.uiservice.showSnackbar('New record added successfully', null, 3000, true);
            this.fetchDealers();
          }
          else {
            this.uiservice.showSnackbar('Record addition failed', null, 3000, false);
          }
        });
  }

  updateDealer(dealer: Dealer) {
    this.http.put<boolean>('/api/Dealer/' + dealer.id, dealer)
      .subscribe(
        result => {
          this.dbupdate = result;
          if (this.dbupdate) {
            this.uiservice.showSnackbar('Record updated successfully', null, 3000, true);
            this.fetchDealers();
          }
          else {
            this.uiservice.showSnackbar('Record update failed', null, 3000, false);
          }
        });
  }

  deleteDealer(dealer: Dealer) {
    this.http.delete<boolean>('/api/Dealer/' + dealer.id)
      .subscribe(
        result => {
          this.dbupdate = result;
          if (this.dbupdate) {
            this.uiservice.showSnackbar('Record deleted successfully', null, 3000, true);
          }
          else {
            this.uiservice.showSnackbar('Record deletion failed', null, 3000, false);
          }
        });
  }
  onCancel() {
    this.uiservice.showSnackbar('Record cancelled', null, 3000, true);
  }
  getDealerAdGroups(id: number) {


  }
  onImport2() {
    this.uiservice.showSnackbar('All files Translated successfully !  Generating Ads', null, 3000, false);
    this.http.get<boolean>('/api/GenerateAds/')
      .subscribe(result => {
        var adsSuccess = result;
        if (adsSuccess) {
          this.uiservice.showSnackbar('Ads generate successfully', null, 3000, false);
        }
        else {
          this.uiservice.showSnackbar('Failed to generate Ads. Please try again', null, 3000, false);
        }
      });
  }

  onBackgroundJob() {
    this.uiservice.showSnackbar('Calling background job', null, 3000, false);
    this.http.get<boolean>('/api/ScheduledJob/ProcessFiles/')
      .subscribe(result => {
        var scheduledjobSuccess = result;
        if (scheduledjobSuccess) {
          this.uiservice.showSnackbar('Background Job Successfully started', null, 3000, false);
        }
      });

  }

  onImport() {
    this.uiservice.showSnackbar('FTP initiated', null, 3000, false);
    this.http.get<boolean>('/api/FileImport/')
      .subscribe(result => {
        var ftpsuccess = result;
        if (ftpsuccess) {
          this.uiservice.showSnackbar('All files Copied ! Importing CSVs to database', null, 3000, false);
          this.http.get<boolean>('/api/ImportCSV/')
            .subscribe(result => {
              var csvSuccess = result;
              if (csvSuccess) {
                this.uiservice.showSnackbar('All files Imported to db successfully !  Translating imported records', null, 3000, false);
                this.http.get<boolean>('/api/Translation/ProcessTranslation/')
                  .subscribe(result => {
                    var translationSuccess = result;
                    if (translationSuccess) {
                      this.uiservice.showSnackbar('All files Translated successfully !  Generating Ads', null, 3000, false);
                      //this.http.get<boolean>('/api/GenerateAds/')
                      //  .subscribe(result => {
                      //    var adsSuccess = result;
                      //    if (adsSuccess) {
                      //      this.uiservice.showSnackbar('Ads generate successfully', null, 3000, false);
                      //    }
                      //    else {
                      //      this.uiservice.showSnackbar('Failed to generate Ads. Please try again', null, 3000, false);
                      //    }
                      //  });
                    }
                    else {
                      this.uiservice.showSnackbar('Translation for records failed. Please try again', null, 3000, false);
                    }
                  });
              }
              else {
                this.uiservice.showSnackbar('Failed to import files to database. Please try again', null, 3000, false);
              }
            });
        }
        else {
          this.uiservice.showSnackbar('Failed to download files. Please try again', null, 3000, false);
        }
      });
  }

  getFiles() {
    this.uiservice.showSnackbar('FTP initiated', null, 3000, false);
    this.http.get<boolean>('/api/FileImport/')
      .subscribe(result => {

      });
  }

  onImportCSV() {
    this.uiservice.showSnackbar('All files Copied ! Importing CSVs to database', null, 3000, false);
    this.http.get<boolean>('/api/ImportCSV/')
      .subscribe(result => {
        var csvSuccess = result;
        if (csvSuccess) {
          this.uiservice.showSnackbar('All files Imported to db successfully !  Translating imported records', null, 3000, false);
          this.http.get<boolean>('/api/Translation/ProcessTranslation/')
            .subscribe(result => {
              var translationSuccess = result;
              if (translationSuccess) {
                this.uiservice.showSnackbar('All files Translated successfully !  Generating Ads', null, 3000, false);
                this.http.get<boolean>('/api/GenerateAds/')
                  .subscribe(result => {
                    var adsSuccess = result;
                    if (adsSuccess) {
                      this.uiservice.showSnackbar('Ads generate successfully', null, 3000, false);
                    }
                    else {
                      this.uiservice.showSnackbar('Failed to generate Ads. Please try again', null, 3000, false);
                    }
                  });
              }
              else {
                this.uiservice.showSnackbar('Translation for records failed. Please try again', null, 3000, false);
              }
            });
        }
        else {
          this.uiservice.showSnackbar('Failed to import files to database. Please try again', null, 3000, false);
        }
      });
  }

  onProcessTranslation() {
    this.uiservice.showSnackbar('All files Imported to db successfully !  Translating imported records', null, 3000, false);
    this.http.get<boolean>('/api/Translation/ProcessTranslation/')
      .subscribe(result => {
        var translationSuccess = result;
        if (translationSuccess) {
          this.uiservice.showSnackbar('All files Translated successfully !  Generating Ads', null, 3000, false);
          this.http.get<boolean>('/api/GenerateAds/NSM000232-01')
            .subscribe(result => {
              var adsSuccess = result;
              if (adsSuccess) {
                this.uiservice.showSnackbar('Ads generate successfully', null, 3000, false);
              }
              else {
                this.uiservice.showSnackbar('Failed to generate Ads. Please try again', null, 3000, false);
              }
            });
        }
        else {
          this.uiservice.showSnackbar('Translation for records failed. Please try again', null, 3000, false);
        }
      });
  }
  onGenerateAds(feedID: string) {
    this.uiservice.showSnackbar('Ad Generation Started', null, 3000, false);
    this.http.get<boolean>('/api/GenerateAds/GenerateCampaignsByFeedID/' + feedID)
      .subscribe(result => {

      });
  }

  onGenerateAdsByClient(clientID: number) {
    this.uiservice.showSnackbar('Ad Generation Started', null, 3000, false);
    this.http.get<boolean>('/api/GenerateAds/GenerateCampaignsByClient/' + clientID)
      .subscribe(result => {

      });
  }
  onCompareAds() {
    this.uiservice.showSnackbar('CompareAds  Started', null, 3000, false);
    this.http.get<string>('/api/CompareData/77')
      .subscribe(result => {
        alert(result);
      });
  }

  downloadFile(): Observable<any> {

    var body = { filename: 'ExportedFile.zip' };

    return this.http.post('/api/FileImport/DownloadFile/', body, {
      responseType: 'blob',
      headers: new HttpHeaders().append('Content-Type', 'application/zip')
    });

    //return this.http.post('/api/FileImport/GetTestFile/', {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'application/zip',
    //  }), responseType: 'blob'
    //});
  }


}
